/* unplugin-vue-components disabled */import { render } from "./DigitSymbolShape.vue?vue&type=template&id=2a3ed79c&scoped=true"
import script from "./DigitSymbolShape.vue?vue&type=script&lang=js"
export * from "./DigitSymbolShape.vue?vue&type=script&lang=js"

import "./DigitSymbolShape.vue?vue&type=style&index=0&id=2a3ed79c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3ed79c"]])

export default __exports__